import EventBus from '../utils/EventBus';
import axios from 'axios';

const FormWizard = {
    template: `
        <div class="container">
            <transition name="swipe" mode="out-in">
                <router-view></router-view>
            </transition>
         </div>
    `,

    data() {
        return {
            forms: {},
            files: null,
            progress: 0,
        }
    },

    created() {
        EventBus.$on('add-data', (formData, origin) => this.forms[origin] = formData);
        EventBus.$on('add-files', (files) => this.files = files);

        EventBus.$on('complete-wizard', () => {
            for (let form in this.forms) {
                if (this.forms.hasOwnProperty(form)) {
                    this.files.append(form, JSON.stringify(this.forms[form]));
                }
                
                localStorage.clear();
            }

            let config = {
                onUploadProgress(progressEvent) {
                    // set max progress on upload file is 80% time, 20% time is waiting backend response
                    this.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total * 0.3);
                    EventBus.$emit('upload-progress', this.progress);
                }
            };

            axios.post('/verein-des-monats/teilnehmen', this.files, config)
                .then(fileRes => {
                    if(fileRes.data.status === "error") {
                        EventBus.$emit('upload-progress', this.progress = 0);
                        alert('File format is not allowed, please try again!');
                    } else {
                        EventBus.$emit('upload-progress', this.progress = 100);
                        setTimeout(() => {
                            this.$router.push('erfolg');
                            this.forms = Object.assign({});
                        }, 1000);
                    }
                })
                .catch(err => {
                    EventBus.$emit('upload-progress', this.progress = 0);
                    alert('Error occurred, please try again later!');
                    console.error(err);
                });
        });
        
        if(Object.keys(this.forms).length === 0) {
            this.$router.push('verein');
        }
    }
};

export default FormWizard;
